import V2EmptyBoxBlueIcon from "@/components/v2/icon/v2-empty-box-blue-icon";
import { ReactNode } from "react";

interface IEmptyResultProps {
  icon?: JSX.Element;
  reason: ReactNode;
  description?: ReactNode;
  fallbackButton?: JSX.Element;
}

const EmptyResult = ({
  icon = <V2EmptyBoxBlueIcon />,
  reason,
  description,
  fallbackButton,
}: IEmptyResultProps) => {
  return (
    <div className="flex flex-col items-center gap-4 w-fit">
      {icon}

      <div className="flex flex-col gap-4 text-center whitespace-pre-line">
        <span className="text-cb-gray-700">{reason}</span>
        {description && <p>{description}</p>}
      </div>

      <div>{fallbackButton}</div>
    </div>
  );
};

export default EmptyResult;
